import React, {Children} from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";

const FauxHeaderInline = ({children}) => (
  <Box sx={{ display: 'flex' }}>
    {Children.toArray(children).map((child, index, arr) => (
      <Box 
        key={index} 
        className={"FauxHeaderInline-Child"}
        sx={{ pr: index < arr.length - 1 ? 'var(--padding-10px)' : 0 }}
      >
        {child}
      </Box>
    ))}
  </Box>
);

FauxHeaderInline.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
};

export default FauxHeaderInline;